import { useCallback, useState } from 'react';
import { Box, Button, Modal, Text, Title } from '@nimbus-ds/components';
import { useNavegate } from 'App/hooks';
import { useStorage } from 'commons/hooks';
import { trackingOrdersAutoCancelPromotionalModalActivateClick } from 'domains/Orders/tracking';
import useTranslationOrders from 'domains/Orders/useTranslationOrders';

export function OrdersAutoCancelPromotionModal() {
  const { goTo } = useNavegate();
  const t = useTranslationOrders('autoCancel');
  const [open, setOpen] = useState(true);

  const [show, setShow, loaded] = useStorage(
    'orders-auto-cancel-promotional-modal',
    true,
  );

  const onActiveButtonClick = useCallback(() => {
    setShow(false);
    trackingOrdersAutoCancelPromotionalModalActivateClick();
    goTo('/orders/auto-cancel');
  }, [goTo, setShow]);

  const onClose = useCallback(() => {
    setOpen(false);
    setShow(false);
  }, [setShow]);

  return (
    <Modal open={open && show && loaded} onDismiss={onClose} maxWidth="343px">
      <Modal.Header>
        <Box paddingRight="10">
          <Title as="h4" textAlign="left">
            {t('promotionalModal.title')}
          </Title>
        </Box>
      </Modal.Header>
      <Modal.Body padding="none">
        <Box fontSize="h6">
          <Text textAlign="left">{t('promotionalModal.description')}</Text>
        </Box>
      </Modal.Body>
      <Modal.Footer>
        <Button appearance="neutral" onClick={onClose}>
          {t('promotionalModal.closeButton')}
        </Button>
        <Button appearance="primary" onClick={onActiveButtonClick}>
          {t('promotionalModal.activateButton')}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
